import { normalizaNivel } from './nivelApreciacao';

/**
 * Próximo gestor da cadeia de apreciação (NIVEL-04, 2026-10-21).
 *
 * Duas regras que a validação e a promoção aplicam antes de gravar:
 * - `temNivel`: o gestor sugerido (ou escolhido) só serve se o `cod_etapa` dele tem o nível da
 *   etapa pedida (`[1, 3]` para a validação do gestor de equipe, `[4]` para o Nível 2, `[5]`
 *   para o Nível 3). 1 e 3 são o mesmo degrau; 0, 99 e ausente nunca servem.
 * - `exigeProximoGestor`: diz se a gravação PRECISA levar um gestor novo em `evaluator`. Se
 *   precisa e não levou, o hook aborta e abre a escolha — a realização nunca passa de nível
 *   sem gestor. As escritas do pit stop (`prosseguir_gst` 'next' na entrada, 'approved' na
 *   saída) ficam fora: seguem como sempre foram. OM-01 (gestor original cod 4 promovendo
 *   antes da janela do Nível 2) também fica fora, porque ali a realização não muda de mão.
 */
export type AcaoDeApreciacao = 'validar' | 'promover';

export interface ExigeProximoGestorParams {
  acao: AcaoDeApreciacao;
  /** Resultado de `CheckManagerType` para o gestor exibido. */
  managerType?: string;
  /** `prosseguir_gst` como vai ser gravado na realização. */
  prosseguirGst?: string;
  /** Gestor original cod 4 promovendo antes do início da janela do Nível 2 (OM-01). */
  om01?: boolean;
}

export function temNivel(codEtapa: unknown, cods: number[]): boolean {
  const nivel = normalizaNivel(codEtapa);

  if (nivel === 0) return false;

  return cods.some(cod => normalizaNivel(cod) === nivel);
}

export function exigeProximoGestor({ acao, managerType, prosseguirGst, om01 = false }: ExigeProximoGestorParams): boolean {
  if (acao === 'validar') {
    return managerType === 'equipe';
  }

  if (managerType === 'diretoria') return false;

  if (prosseguirGst === 'next' || prosseguirGst === 'approved') return false;

  return !om01;
}
